export default "__VITE_ASSET__DIoLvMu2__"